import { useEffect, useRef, useState } from "react";
import { animate, useInView, useReducedMotion } from "framer-motion";

// Fait défiler le premier nombre d'une valeur ("120+", "Top 8", 1500) de 0 jusqu'à sa valeur
export default function CountUp({ value }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const reduce = useReducedMotion();
  const m = String(value).match(/^(\D*)(\d+)(.*)$/s);
  const target = m ? Number(m[2]) : 0;
  const [n, setN] = useState(m && !reduce ? 0 : target);

  useEffect(() => {
    if (!m || reduce || !inView) return undefined;
    const controls = animate(0, target, { duration: 1.4, ease: [0.22, 1, 0.36, 1], onUpdate: (v) => setN(Math.round(v)) });
    return () => controls.stop();
  }, [inView, target]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!m) return <span ref={ref}>{value}</span>;
  return <span ref={ref}>{m[1]}{n.toLocaleString("fr-FR")}{m[3]}</span>;
}
